export default __webpack_public_path__ + "static/media/promo-ticket.c2835982.svg";